import loadable from '@loadable/component';
import React from 'react';

import Spin from '../../spin/spin';

export const RobotCodeLoadable = loadable(() => import(/* webpackChunkName: "robot-code" */ './robot__code'), {
    fallback: <Spin center delay />,
});
